export const translations = {
  es: {
    common: {
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      add: "Agregar",
      search: "Buscar",
      close: "Cerrar",
      confirm: "Confirmar",
      saving: "Guardando…",
      optional: "opcional",
      yes: "Sí",
      no: "No",
      loading: "Cargando…",
      viewLarge: "Ver en grande",
      photo: "Foto",
      photos: "Fotos",
      removePhoto: "Quitar",
      addPhoto: "Agregar foto",
      takeOrUploadPhoto: "Tomar / subir foto",
      processing: "Procesando…",
    },
    login: {
      title: "Sistema de Recepción",
      subtitle: "bitácora de recepción y paquetería",
      username: "Usuario",
      password: "Contraseña",
      enter: "Entrar",
      entering: "Entrando…",
      fillBoth: "Escribe usuario y contraseña.",
      wrongCredentials: "Usuario o contraseña incorrectos.",
    },
    nav: {
      panel: "Panel",
      registrar: "Registrar",
      directorio: "Directorio",
      historial: "Historial",
      usuarios: "Usuarios",
      accesos: "Accesos",
      ajustes: "Ajustes",
    },
    layout: {
      tagline: "bitácora de recepción",
      logout: "Cerrar sesión",
      role_admin: "Administrador",
      role_recepcionista: "Recepcionista",
      language: "Idioma",
    },
    panel: {
      title: "Panel de recepción",
      subtitle: "Paquetes en espera de que el ocupante pase a firmar y recoger.",
      searchPlaceholder: "Buscar por depto. o nombre…",
      registerPackage: "Registrar paquete",
      pending: "Pendientes",
      deliveredToday: "Entregados hoy",
      totalHistoric: "Total histórico",
      colDept: "Depto",
      colPackage: "Paquete",
      colRecipient: "Destinatario",
      colWait: "Espera",
      colAction: "Acción",
      emptyNoPending: "No hay paquetes pendientes.",
      emptyNoResults: "Sin resultados para esa búsqueda.",
      deliverBtn: "Entregar",
      resendTitle: "Reenviar aviso",
      receivedBy: (date, by) => `recibido ${date} por ${by}`,
      minAgo: "min",
      hAgo: "h",
      dAgo: "d",
      deliveredAndNotified: "Entrega confirmada y aviso enviado.",
      deliveredNoNotify: "Entrega confirmada.",
      resent: "Notificación reenviada.",
      resendFailed: "No se pudo reenviar.",
    },
    registrar: {
      title: "Registrar paquete",
      subtitle: "Al guardar se envía automáticamente el aviso al ocupante (si está habilitado en Ajustes).",
      noOccupantsTitle: "Aún no hay ocupantes registrados",
      noOccupantsBody: "Pide a un administrador que dé de alta al menos un propietario u ocupante en el directorio.",
      courierLabel: "Paquetería / repartidor",
      trackingLabel: "Número de guía (opcional)",
      trackingPlaceholder: "Ej. 1Z999AA10123456784",
      otroLabel: "¿A qué paquetería o repartidor corresponde?",
      otroPlaceholder: "Ej. mensajería local, familiar, tienda…",
      descLabel: "Descripción del paquete",
      descPlaceholder: "Ej. caja mediana, sobre, dos bultos…",
      photosLabel: "Fotos del paquete (opcional)",
      pickerLabel: "Departamento / destinatario",
      searchHint: "Busca por depto., nombre o teléfono…",
      noMatches: "Sin coincidencias.",
      notifyInfoEmail: (email) => `Se notificará por correo a ${email}`,
      notifyInfoWhatsapp: (wa) => ` y por WhatsApp al ${wa}`,
      notifyInfoNoWhatsapp: " · sin WhatsApp registrado",
      notifyAllLabel: (unit, names) => `Notificar también a los demás contactos del depto. ${unit} (${names})`,
      errNoOccupant: "Selecciona a quién va dirigido el paquete.",
      errNoDesc: "Describe el paquete.",
      errNoOtroNote: 'Indica a qué paquetería o repartidor corresponde "Otro".',
      submit: "Registrar y notificar",
      submitting: "Registrando…",
      registeredAndNotified: "Paquete registrado y aviso enviado.",
      registeredNoNotify: (reason) => `Paquete registrado. ${reason || ""}`,
    },
    directorio: {
      title: "Directorio",
      subtitle: "Propietarios y ocupantes agrupados por departamento.",
      addContact: "Agregar contacto",
      searchPlaceholder: "Buscar por nombre, depto, correo o teléfono…",
      noResults: "Sin resultados.",
      contactsCount: (n) => `${n} contacto${n > 1 ? "s" : ""}`,
      altEmailPrefix: "correo alterno: ",
      noEmail: "sin correo",
      langLabel: "Idioma preferente",
    },
    occupantDialog: {
      titleEdit: "Editar contacto",
      titleAdd: "Agregar contacto",
      unit: "Departamento",
      type: "Tipo",
      typeOwner: "Propietario",
      typeOccupant: "Ocupante",
      fullName: "Nombre completo",
      email: "Correo electrónico",
      altEmail: "Correo de recepción alterno (opcional)",
      altEmailPlaceholder: "Si prefiere que le escribamos a otro correo",
      whatsapp: "WhatsApp (opcional)",
      phone: "Teléfono",
      preferredLanguage: "Idioma preferente para notificaciones",
      langEs: "Español",
      langEn: "Inglés",
      missingFields: "Completa departamento, nombre y correo.",
      saveError: "No se pudo guardar el contacto.",
    },
    historial: {
      title: "Historial de entregas",
      subtitleAdmin: "Paquetes ya entregados, con firma digital de quien recibió.",
      readOnlyNote: "Como recepcionista puedes consultar este historial; para editar el directorio o usuarios pide apoyo a un administrador.",
      thisWeek: "Esta semana",
      thisMonth: "Este mes",
      all: "Todo",
      range: "Rango",
      to: "a",
      colDept: "Depto",
      colPackageObs: "Paquete / observaciones",
      colReceivedDelivered: "Recibió / entregó",
      colDate: "Fecha",
      noResultsRange: "No hay entregas en este rango de fechas.",
      received: "Recibió: ",
      other: " (otro / no registrado)",
      delivered: "Entregó: ",
      noFoto: "sin foto",
      page: (p, total, count) => `Página ${p} de ${total} · ${count} entregas`,
    },
    usuarios: {
      title: "Usuarios",
      subtitle: "Cuentas de acceso para recepción y administración.",
      addUser: "Agregar usuario",
      infoBanner: "Recepcionistas: panel de recepción completo, registrar paquetes/entregas y consultar historial. Administradores: acceso total, incluyendo directorio y usuarios.",
      username: "usuario: ",
      deleteTitle: "Eliminar usuario",
      deleteConfirm: (name, role) => `¿Seguro que quieres eliminar a ${name} (${role})? Ya no podrá iniciar sesión. Esta acción no se puede deshacer.`,
      viewLoginHistory: "Ver bitácora de accesos",
    },
    userDialog: {
      titleEdit: "Editar usuario",
      titleAdd: "Agregar usuario",
      fullName: "Nombre completo",
      username: "Usuario",
      passwordNew: "Nueva contraseña (dejar vacío para no cambiar)",
      password: "Contraseña",
      role: "Rol",
      roleRecepcionista: "Recepcionista",
      roleAdmin: "Administrador",
      missingFields: "Completa nombre, usuario y contraseña.",
      saveError: "No se pudo guardar el usuario.",
    },
    accesos: {
      title: "Bitácora de accesos",
      subtitle: "Historial de inicios de sesión, exitosos y fallidos.",
      colDate: "Fecha",
      colUser: "Usuario",
      colRole: "Rol",
      colResult: "Resultado",
      colIp: "IP",
      success: "Exitoso",
      failed: "Fallido",
      page: (p, total) => `Página ${p} de ${total}`,
    },
    ajustes: {
      title: "Ajustes",
      subtitle: "Configuración general del condominio y de los canales de notificación. Solo el administrador puede modificarlo.",
      condoSection: "Condominio",
      condoNameLabel: "Nombre del condominio",
      logoLabel: "Logo (opcional)",
      logoHint: "Se usa en la barra lateral y en la pantalla de inicio de sesión. Si no subes uno, se usa el ícono por default.",
      removeLogo: "Quitar logo",
      couriersSection: "Paqueterías",
      couriersHint: 'Estas son las opciones que verá recepción al registrar un paquete. "Otro" siempre está disponible y no se puede eliminar.',
      couriersPlaceholder: "Ej. Ivoy, Rappi, mensajería local…",
      notifySection: "Notificaciones",
      notifyHint: "Correo por SMTP directo y WhatsApp Cloud API. Estos interruptores controlan si se intenta enviar o no.",
      notifyEnabled: "Enviar notificaciones automáticas al registrar un paquete",
      emailEnabled: "Habilitar correo electrónico",
      emailFrom: "Correo remitente",
      whatsappEnabled: "Habilitar WhatsApp",
      whatsappNumber: "Número de WhatsApp Business",
      saveSettings: "Guardar ajustes",
      saved: "Ajustes guardados.",
      languageSection: "Idioma de la interfaz",
      languageHint: "Cambia el idioma en el que ves la aplicación (no afecta el idioma de las notificaciones, que se define por contacto en el Directorio).",
    },
    deliverDialog: {
      title: "Confirmar entrega",
      whoReceives: "¿Quién recibe?",
      otherOption: "Otro / no registrado…",
      otherNameLabel: "Nombre de quien recibe",
      otherNamePlaceholder: "Ej. familiar, portero de otro turno, etc.",
      observations: "Observaciones (opcional)",
      observationsPlaceholder: "Ej. paquete dañado, se dejó con vecino, etc.",
      signature: "Firma en pantalla",
      evidencePhotos: "Fotos de evidencia (opcional)",
      confirm: "Confirmar entrega",
      errNoWho: "Indica quién recibe.",
      errNoSignature: "Se requiere firma para confirmar.",
      genericError: "No se pudo confirmar la entrega.",
    },
    signaturePad: {
      clear: "Limpiar firma",
    },
  },

  en: {
    common: {
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      search: "Search",
      close: "Close",
      confirm: "Confirm",
      saving: "Saving…",
      optional: "optional",
      yes: "Yes",
      no: "No",
      loading: "Loading…",
      viewLarge: "View larger",
      photo: "Photo",
      photos: "Photos",
      removePhoto: "Remove",
      addPhoto: "Add photo",
      takeOrUploadPhoto: "Take / upload photo",
      processing: "Processing…",
    },
    login: {
      title: "Reception System",
      subtitle: "front-desk & package log",
      username: "Username",
      password: "Password",
      enter: "Sign in",
      entering: "Signing in…",
      fillBoth: "Enter your username and password.",
      wrongCredentials: "Incorrect username or password.",
    },
    nav: {
      panel: "Dashboard",
      registrar: "Log package",
      directorio: "Directory",
      historial: "History",
      usuarios: "Users",
      accesos: "Access log",
      ajustes: "Settings",
    },
    layout: {
      tagline: "front-desk log",
      logout: "Sign out",
      role_admin: "Administrator",
      role_recepcionista: "Front desk",
      language: "Language",
    },
    panel: {
      title: "Front desk dashboard",
      subtitle: "Packages waiting for the resident to sign and pick up.",
      searchPlaceholder: "Search by unit or name…",
      registerPackage: "Log package",
      pending: "Pending",
      deliveredToday: "Delivered today",
      totalHistoric: "All-time total",
      colDept: "Unit",
      colPackage: "Package",
      colRecipient: "Recipient",
      colWait: "Waiting",
      colAction: "Action",
      emptyNoPending: "No packages pending.",
      emptyNoResults: "No results for that search.",
      deliverBtn: "Deliver",
      resendTitle: "Resend notice",
      receivedBy: (date, by) => `received ${date} by ${by}`,
      minAgo: "min",
      hAgo: "h",
      dAgo: "d",
      deliveredAndNotified: "Delivery confirmed and notice sent.",
      deliveredNoNotify: "Delivery confirmed.",
      resent: "Notification resent.",
      resendFailed: "Couldn't resend.",
    },
    registrar: {
      title: "Log a package",
      subtitle: "Saving automatically sends the notice to the resident (if enabled in Settings).",
      noOccupantsTitle: "No residents registered yet",
      noOccupantsBody: "Ask an administrator to add at least one owner or resident in the directory.",
      courierLabel: "Courier",
      trackingLabel: "Tracking number (optional)",
      trackingPlaceholder: "E.g. 1Z999AA10123456784",
      otroLabel: "Which courier or carrier is this?",
      otroPlaceholder: "E.g. local courier, family member, store…",
      descLabel: "Package description",
      descPlaceholder: "E.g. medium box, envelope, two bags…",
      photosLabel: "Package photos (optional)",
      pickerLabel: "Unit / recipient",
      searchHint: "Search by unit, name or phone…",
      noMatches: "No matches.",
      notifyInfoEmail: (email) => `We'll email ${email}`,
      notifyInfoWhatsapp: (wa) => ` and WhatsApp ${wa}`,
      notifyInfoNoWhatsapp: " · no WhatsApp on file",
      notifyAllLabel: (unit, names) => `Also notify the other contacts in unit ${unit} (${names})`,
      errNoOccupant: "Select who the package is for.",
      errNoDesc: "Describe the package.",
      errNoOtroNote: 'Specify which courier "Other" corresponds to.',
      submit: "Log and notify",
      submitting: "Logging…",
      registeredAndNotified: "Package logged and notice sent.",
      registeredNoNotify: (reason) => `Package logged. ${reason || ""}`,
    },
    directorio: {
      title: "Directory",
      subtitle: "Owners and residents grouped by unit.",
      addContact: "Add contact",
      searchPlaceholder: "Search by name, unit, email or phone…",
      noResults: "No results.",
      contactsCount: (n) => `${n} contact${n > 1 ? "s" : ""}`,
      altEmailPrefix: "alternate email: ",
      noEmail: "no email",
      langLabel: "Preferred language",
    },
    occupantDialog: {
      titleEdit: "Edit contact",
      titleAdd: "Add contact",
      unit: "Unit",
      type: "Type",
      typeOwner: "Owner",
      typeOccupant: "Resident",
      fullName: "Full name",
      email: "Email",
      altEmail: "Alternate front-desk email (optional)",
      altEmailPlaceholder: "If they'd rather we write to a different email",
      whatsapp: "WhatsApp (optional)",
      phone: "Phone",
      preferredLanguage: "Preferred language for notifications",
      langEs: "Spanish",
      langEn: "English",
      missingFields: "Fill in unit, name, and email.",
      saveError: "Couldn't save the contact.",
    },
    historial: {
      title: "Delivery history",
      subtitleAdmin: "Packages already delivered, with the recipient's digital signature.",
      readOnlyNote: "As front desk, you can view this history; ask an administrator to edit the directory or users.",
      thisWeek: "This week",
      thisMonth: "This month",
      all: "All",
      range: "Range",
      to: "to",
      colDept: "Unit",
      colPackageObs: "Package / notes",
      colReceivedDelivered: "Received / delivered by",
      colDate: "Date",
      noResultsRange: "No deliveries in this date range.",
      received: "Received by: ",
      other: " (other / not on file)",
      delivered: "Delivered by: ",
      noFoto: "no photo",
      page: (p, total, count) => `Page ${p} of ${total} · ${count} deliveries`,
    },
    usuarios: {
      title: "Users",
      subtitle: "Access accounts for front desk and administration.",
      addUser: "Add user",
      infoBanner: "Front desk: full dashboard access, log packages/deliveries, and view history. Administrators: full access, including directory and users.",
      username: "username: ",
      deleteTitle: "Delete user",
      deleteConfirm: (name, role) => `Delete ${name} (${role})? They will no longer be able to sign in. This cannot be undone.`,
      viewLoginHistory: "View access log",
    },
    userDialog: {
      titleEdit: "Edit user",
      titleAdd: "Add user",
      fullName: "Full name",
      username: "Username",
      passwordNew: "New password (leave blank to keep current)",
      password: "Password",
      role: "Role",
      roleRecepcionista: "Front desk",
      roleAdmin: "Administrator",
      missingFields: "Fill in name, username, and password.",
      saveError: "Couldn't save the user.",
    },
    accesos: {
      title: "Access log",
      subtitle: "Login history, both successful and failed.",
      colDate: "Date",
      colUser: "User",
      colRole: "Role",
      colResult: "Result",
      colIp: "IP",
      success: "Success",
      failed: "Failed",
      page: (p, total) => `Page ${p} of ${total}`,
    },
    ajustes: {
      title: "Settings",
      subtitle: "General condo configuration and notification channels. Administrator only.",
      condoSection: "Condominium",
      condoNameLabel: "Condominium name",
      logoLabel: "Logo (optional)",
      logoHint: "Used in the sidebar and the login screen. If none is uploaded, the default icon is used.",
      removeLogo: "Remove logo",
      couriersSection: "Couriers",
      couriersHint: 'These are the options front desk sees when logging a package. "Other" is always available and can\u2019t be removed.',
      couriersPlaceholder: "E.g. Ivoy, Rappi, local courier…",
      notifySection: "Notifications",
      notifyHint: "Direct SMTP email and WhatsApp Cloud API. These switches control whether sending is attempted.",
      notifyEnabled: "Send automatic notifications when a package is logged",
      emailEnabled: "Enable email",
      emailFrom: "Sender email",
      whatsappEnabled: "Enable WhatsApp",
      whatsappNumber: "WhatsApp Business number",
      saveSettings: "Save settings",
      saved: "Settings saved.",
      languageSection: "Interface language",
      languageHint: "Changes the language you see the app in (doesn't affect notification language, which is set per contact in the Directory).",
    },
    deliverDialog: {
      title: "Confirm delivery",
      whoReceives: "Who's receiving it?",
      otherOption: "Other / not on file…",
      otherNameLabel: "Name of the person receiving it",
      otherNamePlaceholder: "E.g. family member, another shift's doorman, etc.",
      observations: "Notes (optional)",
      observationsPlaceholder: "E.g. package damaged, left with neighbor, etc.",
      signature: "On-screen signature",
      evidencePhotos: "Evidence photos (optional)",
      confirm: "Confirm delivery",
      errNoWho: "Specify who's receiving it.",
      errNoSignature: "A signature is required to confirm.",
      genericError: "Couldn't confirm the delivery.",
    },
    signaturePad: {
      clear: "Clear signature",
    },
  },
};

export const LANGS = [
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
];
